import cookie from 'js/lib/cookie';

export function joinProgram(programId: string, userId: number) {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  };

  const csrfToken = cookie.get('CSRF3-Token');
  if (csrfToken) {
    headers['X-Csrf3-Token'] = csrfToken;
  }

  const promise = fetch(`/api/programInvitations.v1?programId=${programId}&userId=${userId}&action=join`, {
    method: 'POST',
    body: '{}',
    headers,
  }).then((res) => {
    if (res.status >= 200 && res.status < 300) {
      return res.json();
    } else {
      throw res;
    }
  });

  return promise;
}

export function joinMultiPrograms(programIds: string[], userId: number) {
  const promises: Array<Promise<any>> = [];

  for (const programId of programIds) {
    const promise = joinProgram(programId, userId);
    promises.push(promise);
  }

  return Promise.all(promises);
}
